import React, { PureComponent } from 'react';

import { Field } from 'components/ClubComponents';
import { Configuration } from 'components/configuration';
import { Toggle } from 'components/toggle';
import { I18n, translate } from 'components/translate';
import { isNil } from 'helpers/Array';
import { withFeatureToggle } from 'hoc/withFeatureToggle';
import get from 'lodash/get';
import { PERSONA_NAME_MAX_LENGTH } from 'modules/community/constants';
import { FeatureToggles } from 'modules/featureToggle';
import PropTypes from 'prop-types';

import AvatarUpload from './personaAvatar/AvatarUpload';

const AVATAR_FILE_PARAMS = { size: '300px' };

@translate()
class PersonaConfiguration extends PureComponent {
  static propTypes = {
    t: PropTypes.func,
    onChange: PropTypes.func,
    errors: PropTypes.object,
    fields: PropTypes.object
  };

  constructor(props) {
    super(props);

    const { t } = props;

    this.toggleLabels = {
      on: t('general.yes'),
      off: t('general.no')
    };
  }

  handleChange = (e) => {
    const { fields, onChange } = this.props;

    if (!fields.personaActive) {
      return;
    }

    onChange && onChange(e);
  };

  renderNameError() {
    const { errors, t } = this.props;

    if (isNil(get(errors, 'personaName'))) {
      return null;
    }

    return (
      <span data-test="persona-name-error">
        <I18n
          label="general.required_parameter"
          data={{
            field: t(
              'community.configuration.persona.topic_form_fields.name_title'
            )
          }}
        />
      </span>
    );
  }

  render() {
    const { t, fields, onChange } = this.props;
    const disabled = !fields.personaActive;

    return (
      <Configuration
        data-test="ca-persona-configuration"
        className="persona-configuration"
        title={<I18n label="community.configuration.persona.title" />}
      >
        <Configuration.Item
          title={<I18n label="community.configuration.persona.topic_title" />}
          description={
            <I18n label="community.configuration.persona.topic_explain" />
          }
          trailing={
            <Toggle
              data-test="ca-persona-toggle"
              label={this.toggleLabels}
              name="personaActive"
              checked={fields.personaActive}
              onChange={onChange}
              id="personaActive"
            />
          }
        />
        <Configuration.Item disabled={disabled}>
          <Field
            className="_mt-5"
            label={
              <I18n label="community.configuration.persona.topic_form_fields.name_title" />
            }
            error={this.renderNameError()}
          >
            <input
              type="text"
              className="hot-form__input hot-form__input--md"
              placeholder={t(
                'community.configuration.persona.topic_form_fields.name_placeholder'
              )}
              id="personaName"
              name="personaName"
              value={fields.personaName}
              onChange={this.handleChange}
              disabled={disabled}
              maxLength={PERSONA_NAME_MAX_LENGTH}
            />
          </Field>
        </Configuration.Item>
        <Configuration.Item
          title={
            <I18n label="community.configuration.persona.topic_form_fields.avatar_title" />
          }
          description={
            <I18n
              label="community.configuration.persona.topic_form_fields.avatar_title_explain"
              data={AVATAR_FILE_PARAMS}
            />
          }
          disabled={disabled}
        >
          <AvatarUpload
            name="personaAvatar"
            value={fields.personaAvatar}
            onChange={this.handleChange}
            disabled={disabled}
          />
        </Configuration.Item>
      </Configuration>
    );
  }
}

export default withFeatureToggle(
  PersonaConfiguration,
  FeatureToggles.PersonaConfig
);
